import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftQuotaServer } from "namirasoft-quota";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { QuotaLayout } from "./QuotaLayout";
import { QuotaRoutes } from "./QuotaRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import { RequestEditPage } from "./pages/RequestEditPage";
import { RequestListPage } from "./pages/RequestListPage";
import { RequestViewPage } from "./pages/RequestViewPage";
import { UsagePage } from "./pages/UsagePage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_QUOTA}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_QUOTA = new EnvService("REACT_APP_BASE_URL_QUOTA", true).getString();

            let quota = new NamirasoftQuotaServer(REACT_APP_BASE_URL_QUOTA, result.account.token_manager, result.notifier.onError);

            let servers = { quota };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={QuotaRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={QuotaRoutes.RequestList} element={<RequestListPage {...result} servers={servers} />} />
                            <Route path={QuotaRoutes.RequestNew} element={<RequestEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={QuotaRoutes.RequestView(":id")} element={<RequestViewPage {...result} servers={servers} />} />
                            <Route path={QuotaRoutes.RequestEdit(":id")} element={<RequestEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={QuotaRoutes.RequestCopy(":id")} element={<RequestEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={QuotaRoutes.Usage} element={<UsagePage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={QuotaRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <QuotaLayout {...props}>
                {props.children}
            </QuotaLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;